import React from 'react';

import { Grid, IconButton, RemoveCircleOutlineIcon } from '@gogame/components';
import { FormField } from '@gogame/form';

import { PERIOD_START_DATE, OWNER_ID } from '../constants';

const isOwnerBlocked = ({ isBlocked }) => isBlocked;
export const OwnerItem = ({
  index,
  onRemove,
  max,
  min,
  onLoadOwners,
  isCurrentOwner,
  isFirst,
}) => {
  const handleRemove = () => onRemove(index);
  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <FormField.Select
          name={OWNER_ID}
          withDeselectButton={true}
          required={true}
          padding={'0'}
          source={onLoadOwners}
          label={isCurrentOwner ? 'Current owner' : 'Owner'}
          isOptionDisabled={isOwnerBlocked}
        />
      </Grid>
      <Grid item xs={5}>
        <FormField.DatePicker
          name={PERIOD_START_DATE}
          padding={'0'}
          label={'Start date *'}
          minDate={min}
          maxDate={max}
          disabled={isFirst}
        />
      </Grid>
      <Grid item xs={1}>
        <IconButton
          icon={<RemoveCircleOutlineIcon />}
          tooltip={'Remove Owner'}
          onClick={handleRemove}
          disabled={isFirst}
        />
      </Grid>
    </Grid>
  );
};

export default OwnerItem;
